import React, { useState, useEffect } from 'react';
import {
    Grid,
    TextField,
    Button,
    Autocomplete,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    TablePagination,
    FormControlLabel,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import Swal from 'sweetalert2';
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';
import { useSucursal } from '../contexts/SucursalContext';

const GestionTipoTransacciones = () => {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const { user } = useUser();
    const { sucursalSeleccionada } = useSucursal();

    const [descripcion, setDescripcion] = useState('');
    const [comision, setComision] = useState(0);
    const [mostrarCierre, setMostrarCierre] = useState(false);
    const [egreso, setEgreso] = useState(false);
    const [llevaComision, setLlevaComision] = useState(false);
    const [comisionEsMontoFijo, setComisionEsMontoFijo] = useState(false); // Cambiado a false por defecto
    const [cuentasContables, setCuentasContables] = useState([]);
    const [cuentasBancarias, setCuentasBancarias] = useState([]);
    const [tiposTransaccionPadre, setTiposTransaccionPadre] = useState([]);

    const [cuentaContableSeleccionada, setCuentaContableSeleccionada] = useState(null);
    const [cuentaContableNewSeleccionada, setCuentaContableNewSeleccionada] = useState(null);
    const [cuentaContableComisionSeleccionada, setCuentaContableComisionSeleccionada] = useState(null);
    const [cuentaContableComisionNewSeleccionada, setCuentaContableComisionNewSeleccionada] = useState(null);
    const [cuentaBancariaSeleccionada, setCuentaBancariaSeleccionada] = useState(null);
    const [grupoSeleccionado, setGrupoSeleccionado] = useState(null);
    const [cuentasContablesNew, setCuentasContablesNew] = useState([]);
    const [transacciones, setTransacciones] = useState([]);

    const [isEditing, setIsEditing] = useState(false); // Indica si se está editando
    const [editId, setEditId] = useState(null); // ID del elemento en edición

    // Paginación
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const [grupos, setGrupos] = useState([]); // Reemplaza tiposTransaccionPadre por grupos

    // Estado para el modal de grupo
    const [openGrupoModal, setOpenGrupoModal] = useState(false);
    const [grupoNombre, setGrupoNombre] = useState('');
    const [grupoMostrarCierre, setGrupoMostrarCierre] = useState(false);

    // Estado para el término de búsqueda
    const [searchQuery, setSearchQuery] = useState('');

    // Función para filtrar las transacciones según el término de búsqueda
    const filteredTransacciones = transacciones.filter((transaccion) => {
        const query = searchQuery.toLowerCase();
        return (
            transaccion.descripcionTipoTransaccion.toLowerCase().includes(query) ||
            (transaccion.cuentaContableDescripcion && transaccion.cuentaContableDescripcion.toLowerCase().includes(query)) ||
            (transaccion.cuentaBancariaNombre && transaccion.cuentaBancariaNombre.toLowerCase().includes(query)) ||
            (transaccion.grupo && transaccion.grupo.toLowerCase().includes(query))
        );
    });



    const fetchGrupos = async () => {
        try {
            const response = await fetch(`${server}/MgCajaTipoTransaccionGrupoes`);
            const data = await response.json();
            setGrupos(data.$values || []);
        } catch (error) {
            console.error('Error al cargar grupos:', error);
        }
    };
    const handleGuardarGrupo = async () => {
        if (!grupoNombre) {
            Swal.fire('Error', 'Ingrese un nombre para el grupo.', 'error');
            return;
        }

        const payload = {
            grupo: grupoNombre,
            mostrarEnCierreCaja: grupoMostrarCierre,
            ingresadoPor: user?.codigoUsuario || 'ADMIN',
        };

        try {
            const response = await fetch(`${server}/MgCajaTipoTransaccionGrupoes`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            if (response.ok) {
                Swal.fire('Éxito', 'Grupo guardado correctamente.', 'success');
                fetchGrupos();
                setOpenGrupoModal(false);
                setGrupoNombre('');
                setGrupoMostrarCierre(false);
            } else {
                const errorData = await response.json();
                Swal.fire('Error', errorData.message || 'Ocurrió un error al guardar el grupo.', 'error');
            }
        } catch (error) {
            console.error('Error al guardar el grupo:', error);
            Swal.fire('Error', 'Ocurrió un error inesperado.', 'error');
        }
    };
    useEffect(() => {
        fetchCuentasContables();
        fetchCuentasContablesNew();
        fetchCuentasBancarias();
        fetchGrupos();
        fetchTransacciones();
    }, [sucursalSeleccionada]);

    const fetchCuentasContables = async () => {
        try {
            const response = await fetch(`${server}/CntCuentasContablesDetalles`);
            const data = await response.json();
            console.log(data);
            setCuentasContables(data.$values || []);
        } catch (error) {
            console.error('Error al cargar cuentas contables:', error);
        }
    };

    const fetchCuentasContablesNew = async () => {
        try {
            const response = await fetch(`${server}/CtbPlanDeCuentas/detalle`);
            const data = await response.json();
            console.log('Plan de cuentas nivel 5:', data);
            // Filtrar solo las cuentas de nivel 5 (que aceptan movimientos)
            const cuentasNivel5 = (data.$values || data).filter(cuenta => 
                (cuenta.nivel || cuenta.Nivel) === 5
            );
            setCuentasContablesNew(cuentasNivel5);
        } catch (error) {
            console.error('Error al cargar plan de cuentas nuevo:', error);
        }
    };

    const fetchCuentasBancarias = async () => {
        try {
            const response = await fetch(`${server}/ChkBancosCuentasBancarias`);
            const data = await response.json();
            setCuentasBancarias(data.$values || []);
        } catch (error) {
            console.error('Error al cargar cuentas bancarias:', error);
        }
    };

    const fetchTiposTransaccionPadre = async () => {
        try {
            const response = await fetch(`${server}/MgCajaTipoTransaccions`);
            const data = await response.json();
            setTiposTransaccionPadre(data.$values || []);
        } catch (error) {
            console.error('Error al cargar tipos de transacción padre:', error);
        }
    };

    const fetchTransacciones = async () => {
        try {
            const response = await fetch(`${server}/MgCajaTipoTransaccions`);
            const data = await response.json();
            setTransacciones(data.$values || []);
            console.log(data.$values);
        } catch (error) {
            console.error('Error al cargar transacciones:', error);
        }
    };

    const handleGuardar = async () => {
        if (!descripcion || !cuentaContableSeleccionada || !cuentaBancariaSeleccionada) {
            Swal.fire('Error', 'Por favor complete todos los campos obligatorios.', 'error');
            return;
        }

        // Crear el payload con los datos necesarios (sin incluir id)
        const payload = {
            descripcionTipoTransaccion: descripcion,
            idCuentaContable: cuentaContableSeleccionada?.id || null,
            idCuentaContableNew: cuentaContableNewSeleccionada?.idCuenta || cuentaContableNewSeleccionada?.IdCuenta || null,
            idCuentaBancaria: cuentaBancariaSeleccionada.idCuentaBancaria,
            idGrupo: grupoSeleccionado?.id || null,
            egreso: egreso,
            mostrarEnCierreCaja: mostrarCierre,
            comision: comision ? parseFloat(comision) : 0,
            idCuentaContableComision: cuentaContableComisionSeleccionada?.id || null,
            idCuentaContableComisionNew: cuentaContableComisionNewSeleccionada?.idCuenta || cuentaContableComisionNewSeleccionada?.IdCuenta || null,
            comisionEsMontoFijo: comisionEsMontoFijo, // Agregar la nueva propiedad
        };

        // Validar que solo cuando se edita se mande el id y se use 'modificadoPor'
        if (isEditing) {
            payload.id = editId; // Se añade el id solo en modo edición
            payload.modificadoPor = user?.codigoUsuario || 'ADMIN';
            // Al editar, mantener el orden existente si no se especifica
            const transaccionActual = transacciones.find(t => t.id === editId);
            if (transaccionActual) {
                payload.orden = transaccionActual.orden || 0;
            }
        } else {
            payload.ingresadoPor = user?.codigoUsuario || 'ADMIN';
            // Para nuevas transacciones, asignar el siguiente número de orden
            const maxOrden = Math.max(...transacciones.map(t => t.orden || 0), 0);
            payload.orden = maxOrden + 1;
        }

        console.log(payload);

        try {
            // Decidir la URL y el método según si se edita o se crea nuevo
            const url = isEditing
                ? `${server}/MgCajaTipoTransaccions/${editId}` // Para editar
                : `${server}/MgCajaTipoTransaccions`; // Para guardar nuevo

            const method = isEditing ? 'PUT' : 'POST';

            // Realizar la solicitud
            const response = await fetch(url, {
                method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            if (response.ok) {
                Swal.fire(
                    'Éxito',
                    `El tipo de transacción se ${isEditing ? 'actualizó' : 'guardó'} correctamente.`,
                    'success'
                );
                fetchTransacciones(); // Recargar la tabla
                fetchGrupos();
                resetForm(); // Restablecer el formulario
            } else {
                const errorData = await response.json();
                Swal.fire('Error', errorData.message || 'Ocurrió un error al guardar el tipo de transacción.', 'error');
            }
        } catch (error) {
            console.error('Error al guardar el tipo de transacción:', error);
            Swal.fire('Error', 'Ocurrió un error inesperado.', 'error');
        }
    };



    const handleEliminar = async (id) => {
        Swal.fire({
            title: '¿Está seguro?',
            text: 'Esta acción no se puede deshacer.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const username = '' + user.codigoUsuario + '/';
                    console.log(username);
                    const response = await fetch(`${server}/MgCajaTipoTransaccions/${id}/${username}`, {
                        method: 'DELETE',
                    });

                    if (response.ok) {
                        Swal.fire('Eliminado', 'El tipo de transacción ha sido eliminado.', 'success');
                        fetchTransacciones(); // Recargar la tabla
                    } else {
                        const errorData = await response.json();
                        Swal.fire('Error', errorData.message || 'Ocurrió un error al eliminar el tipo de transacción.', 'error');
                    }
                } catch (error) {
                    console.error('Error al eliminar el tipo de transacción:', error);
                    Swal.fire('Error', 'Ocurrió un error inesperado.', 'error');
                }
            }
        });
    };

    const handleEditar = (transaccion) => {
        console.log(transaccion);
        setDescripcion(transaccion.descripcionTipoTransaccion);
        setCuentaContableSeleccionada(
            cuentasContables.find((c) => c.id === transaccion.idCuentaContable)
        );
        setCuentaContableNewSeleccionada(
            cuentasContablesNew.find((c) => (c.idCuenta || c.IdCuenta) === transaccion.idCuentaContableNew)
        );
        setCuentaBancariaSeleccionada(
            cuentasBancarias.find((b) => b.idCuentaBancaria === transaccion.idCuentaBancaria)
        );
        setGrupoSeleccionado(
            grupos.find((g) => g.id === transaccion.idGrupo)
        );
        setEditId(transaccion.id);
        setIsEditing(true);
        setComision(transaccion.comision || '');
        setCuentaContableComisionSeleccionada(
            cuentasContables.find((c) => c.id === transaccion.idCuentaContableComision)
        );
        setCuentaContableComisionNewSeleccionada(
            cuentasContablesNew.find((c) => (c.idCuenta || c.IdCuenta) === transaccion.idCuentaContableComisionNew)
        );
        setMostrarCierre(transaccion.mostrarEnCierreCaja);
        setEgreso(transaccion.egreso);
        setLlevaComision(transaccion.comision > 0 || Boolean(transaccion.comisionEsMontoFijo));
        setComisionEsMontoFijo(Boolean(transaccion.comisionEsMontoFijo));
    };


    // Función para actualizar orden de transacción
    const updateOrdenTransaccion = async (id, nuevoOrden) => {
        try {
            const transaccion = transacciones.find(t => t.id === id);
            if (!transaccion) return;

            // Crear payload completo con todos los campos necesarios
            const payload = {
                id: transaccion.id,
                descripcionTipoTransaccion: transaccion.descripcionTipoTransaccion,
                idCuentaContable: transaccion.idCuentaContable,
                idCuentaBancaria: transaccion.idCuentaBancaria,
                idGrupo: transaccion.idGrupo,
                egreso: transaccion.egreso,
                mostrarEnCierreCaja: transaccion.mostrarEnCierreCaja,
                comision: transaccion.comision,
                idCuentaContableComision: transaccion.idCuentaContableComision,
                comisionEsMontoFijo: transaccion.comisionEsMontoFijo,
                orden: nuevoOrden,
                modificadoPor: user?.codigoUsuario || 'ADMIN'
            };

            console.log('Actualizando orden - Payload:', payload);

            const response = await fetch(`${server}/MgCajaTipoTransaccions/${id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                await fetchTransacciones();
            } else {
                const errorData = await response.json();
                console.error('Error del servidor:', errorData);
                Swal.fire('Error', 'No se pudo actualizar el orden', 'error');
            }
        } catch (error) {
            console.error('Error al actualizar orden:', error);
            Swal.fire('Error', 'Ocurrió un error al actualizar el orden', 'error');
        }
    };

    // Función para mover transacción hacia arriba
    const handleMoveUpTransaccion = async (index) => {
        if (index === 0) return; // No se puede mover más arriba

        const currentTransaccion = filteredTransacciones[index];
        const previousTransaccion = filteredTransacciones[index - 1];

        // Si todos tienen orden 0 o el mismo orden, usar el índice como orden
        const currentOrden = currentTransaccion.orden || index;
        const previousOrden = previousTransaccion.orden || (index - 1);

        // Intercambiar órdenes usando los índices si es necesario
        await updateOrdenTransaccion(currentTransaccion.id, previousOrden);
        await updateOrdenTransaccion(previousTransaccion.id, currentOrden);

        Swal.fire({
            icon: 'success',
            title: 'Orden actualizado',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 1500
        });
    };

    // Función para mover transacción hacia abajo
    const handleMoveDownTransaccion = async (index) => {
        if (index === filteredTransacciones.length - 1) return; // No se puede mover más abajo

        const currentTransaccion = filteredTransacciones[index];
        const nextTransaccion = filteredTransacciones[index + 1];

        // Si todos tienen orden 0 o el mismo orden, usar el índice como orden
        const currentOrden = currentTransaccion.orden || index;
        const nextOrden = nextTransaccion.orden || (index + 1);

        // Intercambiar órdenes usando los índices si es necesario
        await updateOrdenTransaccion(currentTransaccion.id, nextOrden);
        await updateOrdenTransaccion(nextTransaccion.id, currentOrden);

        Swal.fire({
            icon: 'success',
            title: 'Orden actualizado',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 1500
        });
    };

    // Función para inicializar órdenes secuencialmente
    const handleInicializarOrdenes = async () => {
        const result = await Swal.fire({
            title: '¿Inicializar órdenes?',
            text: 'Esto asignará números de orden secuenciales a todas las transacciones según su posición actual.',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, inicializar',
            cancelButtonText: 'Cancelar'
        });

        if (!result.isConfirmed) return;

        try {
            // Asignar orden secuencial a cada transacción
            for (let i = 0; i < filteredTransacciones.length; i++) {
                await updateOrdenTransaccion(filteredTransacciones[i].id, i + 1);
            }

            Swal.fire({
                icon: 'success',
                title: 'Órdenes inicializados',
                text: 'Se han asignado números de orden a todas las transacciones',
                timer: 2000
            });
        } catch (error) {
            console.error('Error al inicializar órdenes:', error);
            Swal.fire('Error', 'No se pudieron inicializar los órdenes', 'error');
        }
    };

    const resetForm = () => {
        setDescripcion('');
        setCuentaContableSeleccionada(null);
        setCuentaContableNewSeleccionada(null);
        setCuentaContableComisionSeleccionada(null);
        setCuentaContableComisionNewSeleccionada(null);
        setComision(0);
        setCuentaBancariaSeleccionada(null);
        setGrupoSeleccionado(null);
        setMostrarCierre(false);
        setEgreso(false);
        setLlevaComision(false);
        setComisionEsMontoFijo(false);
        setIsEditing(false);
        setEditId(null);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    // Manejo de paginación
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <div className="right_col" role="main">
            <div className="x_content">
                {/* <div className="row"> */}
                {/* <div className="col-md-9 col-sm-7 offset-md-2"> */}
                <h1>Gestión de Tipo de Transacciones</h1>
                <Grid container spacing={2}>
                    {/* Formulario */}
                    <Grid item xs={12} sm={6}>
                        <TextField
                            label="Descripción"
                            value={descripcion}
                            onChange={(e) => setDescripcion(e.target.value)}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={mostrarCierre}
                                    onChange={(e) => setMostrarCierre(e.target.checked)}
                                />
                            }
                            label="Mostrar en Cierrre"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Autocomplete
                            options={cuentasContables}
                            getOptionLabel={(option) => option.descripcion || ''}
                            value={cuentaContableSeleccionada}
                            onChange={(e, value) => setCuentaContableSeleccionada(value)}
                            renderInput={(params) => <TextField {...params} label="Cuenta Contable (Legacy)" fullWidth />}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Autocomplete
                            options={cuentasContablesNew}
                            getOptionLabel={(option) => `${option.codigo || option.Codigo} - ${option.descripcion || option.Descripcion}`}
                            value={cuentaContableNewSeleccionada}
                            onChange={(e, value) => setCuentaContableNewSeleccionada(value)}
                            renderInput={(params) => <TextField {...params} label="Cuenta Contable (Nueva)" fullWidth />}
                            isOptionEqualToValue={(option, value) => {
                                if (!option || !value) return false;
                                return (option.idCuenta || option.IdCuenta) === (value.idCuenta || value.IdCuenta);
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Autocomplete
                            options={cuentasBancarias}
                            getOptionLabel={(option) => option.cuentaBancaria || ''}
                            value={cuentaBancariaSeleccionada}
                            onChange={(e, value) => setCuentaBancariaSeleccionada(value)}
                            renderInput={(params) => <TextField {...params} label="Cuenta Bancaria" fullWidth />}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={llevaComision}
                                    onChange={(e) => setLlevaComision(e.target.checked)}
                                />
                            }
                            label="Lleva Comisión"
                        />
                    </Grid>
                    {llevaComision && (
                        <>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Comisión"
                                    value={comision}
                                    onChange={(e) => setComision(e.target.value)}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={comisionEsMontoFijo}
                                            onChange={(e) => setComisionEsMontoFijo(e.target.checked)}
                                        />
                                    }
                                    label="Comisión es Monto Fijo"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Autocomplete
                                    options={cuentasContables}
                                    getOptionLabel={(option) => option.descripcion || ''}
                                    value={cuentaContableComisionSeleccionada}
                                    onChange={(e, value) => setCuentaContableComisionSeleccionada(value)}
                                    renderInput={(params) => <TextField {...params} label="Cuenta Contable Comision (Legacy)" fullWidth />}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Autocomplete
                                    options={cuentasContablesNew}
                                    getOptionLabel={(option) => `${option.codigo || option.Codigo} - ${option.descripcion || option.Descripcion}`}
                                    value={cuentaContableComisionNewSeleccionada}
                                    onChange={(e, value) => setCuentaContableComisionNewSeleccionada(value)}
                                    renderInput={(params) => <TextField {...params} label="Cuenta Contable Comision (Nueva)" fullWidth />}
                                    isOptionEqualToValue={(option, value) => {
                                        if (!option || !value) return false;
                                        return (option.idCuenta || option.IdCuenta) === (value.idCuenta || value.IdCuenta);
                                    }}
                                />
                            </Grid>
                        </>
                    )}
                    <Grid item xs={12} sm={6}>
                        <Autocomplete
                            options={grupos} // Cambia tiposTransaccionPadre por grupos
                            getOptionLabel={(option) => option.grupo || ''} // Asegúrate de que el campo sea correcto
                            value={grupoSeleccionado} // Cambia tipoTransaccionPadreSeleccionado por grupoSeleccionado
                            onChange={(e, value) => setGrupoSeleccionado(value)} // Cambia setTipoTransaccionPadreSeleccionado por setGrupoSeleccionado
                            renderInput={(params) => <TextField {...params} label="Grupo" fullWidth />}
                        />
                        <IconButton onClick={() => setOpenGrupoModal(true)} color="primary">
                            <AddIcon />
                        </IconButton>
                    </Grid>

                    <Grid item xs={12} sm={3}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={egreso}
                                    onChange={(e) => setEgreso(e.target.checked)}
                                />
                            }
                            label="Egreso"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleGuardar}
                            disabled={!tienePermiso('Crear Tipo Transacción')}
                        >
                            {isEditing ? 'Actualizar' : 'Guardar'}
                        </Button>
                        {isEditing && (
                            <Button
                                variant="outlined"
                                color="secondary"
                                onClick={resetForm}
                                style={{ marginLeft: '10px' }}
                            >
                                Cancelar
                            </Button>
                        )}
                    </Grid>
                </Grid>

                {/* Tabla con paginación */}
                <h2>Listado de Tipos de Transacciones</h2>
                {/* Campo de búsqueda y botón inicializar órdenes */}
                <Grid container spacing={2} style={{ marginBottom: 20 }}>
                    <Grid item xs={12} sm={8}>
                        <TextField
                            label="Buscar"
                            variant="outlined"
                            fullWidth
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Button
                            variant="outlined"
                            color="primary"
                            fullWidth
                            onClick={handleInicializarOrdenes}
                            style={{ height: '56px' }}
                            disabled={!tienePermiso('Inicializar Órdenes Transacción')}
                        >
                            Inicializar Órdenes
                        </Button>
                    </Grid>
                </Grid>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Descripción</TableCell>
                                <TableCell>Cuenta Contable</TableCell>
                                <TableCell>Cuenta Bancaria</TableCell>
                                <TableCell>Grupo</TableCell>
                                <TableCell>Comision</TableCell>
                                <TableCell>Comisión Fija</TableCell>
                                <TableCell>Cuenta Contable C.</TableCell>
                                <TableCell>Egreso</TableCell>
                                <TableCell>Mostrar en Cierre</TableCell>
                                <TableCell>Orden</TableCell>
                                <TableCell>Ordenar</TableCell>
                                <TableCell>Acciones</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredTransacciones
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((transaccion, index) => {
                                    const globalIndex = page * rowsPerPage + index;
                                    return (
                                    <TableRow key={transaccion.id}>
                                        <TableCell>{transaccion.descripcionTipoTransaccion}</TableCell>
                                        <TableCell>
                                            {(() => {
                                                const cuenta = cuentasContablesNew.find(c => 
                                                    (c.idCuenta || c.IdCuenta) === transaccion.idCuentaContableNew
                                                );
                                                return cuenta ? `${cuenta.codigo || cuenta.Codigo} - ${cuenta.descripcion || cuenta.Descripcion}` : 'N/A';
                                            })()}
                                        </TableCell>
                                        <TableCell>{transaccion.cuentaBancaria}</TableCell>
                                        <TableCell>{transaccion.grupo || 'N/A'}</TableCell>
                                        <TableCell>{transaccion.comision}</TableCell>
                                        <TableCell>
                                            <Checkbox checked={transaccion.comisionEsMontoFijo} disabled />
                                        </TableCell>
                                        <TableCell>
                                            {(() => {
                                                const cuenta = cuentasContablesNew.find(c => 
                                                    (c.idCuenta || c.IdCuenta) === transaccion.idCuentaContableComisionNew
                                                );
                                                return cuenta ? `${cuenta.codigo || cuenta.Codigo} - ${cuenta.descripcion || cuenta.Descripcion}` : 'N/A';
                                            })()}
                                        </TableCell>
                                        <TableCell>
                                            {/* Representamos el campo "Mostrar en Cierre" con un Checkbox */}
                                            <Checkbox checked={transaccion.egreso} disabled />
                                        </TableCell>
                                        <TableCell>
                                            {/* Representamos el campo "Mostrar en Cierre" con un Checkbox */}
                                            <Checkbox checked={transaccion.mostrarEnCierreCaja} disabled />
                                        </TableCell>
                                        <TableCell>{transaccion.orden || 0}</TableCell>
                                        <TableCell>
                                            <IconButton
                                                onClick={() => handleMoveUpTransaccion(globalIndex)}
                                                disabled={globalIndex === 0 || !tienePermiso('Ordenar Tipo Transacción')}
                                                color="primary"
                                                size="small"
                                            >
                                                <ArrowUpwardIcon />
                                            </IconButton>
                                            <IconButton
                                                onClick={() => handleMoveDownTransaccion(globalIndex)}
                                                disabled={globalIndex === filteredTransacciones.length - 1 || !tienePermiso('Ordenar Tipo Transacción')}
                                                color="primary"
                                                size="small"
                                            >
                                                <ArrowDownwardIcon />
                                            </IconButton>
                                        </TableCell>
                                        <TableCell>
                                            <IconButton
                                                onClick={() => handleEditar(transaccion)}
                                                color="primary"
                                                disabled={!tienePermiso('Editar Tipo Transacción')}
                                            >
                                                <EditIcon />
                                            </IconButton>
                                            <IconButton
                                                onClick={() => handleEliminar(transaccion.id)}
                                                color="error"
                                                disabled={!tienePermiso('Eliminar Tipo Transacción')}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={transacciones.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />

                {/* </div> */}
                <Dialog open={openGrupoModal} onClose={() => setOpenGrupoModal(false)}>
                    <DialogTitle>Crear Grupo</DialogTitle>
                    <DialogContent>
                        <TextField
                            label="Nombre del Grupo"
                            value={grupoNombre}
                            onChange={(e) => setGrupoNombre(e.target.value)}
                            fullWidth
                            margin="dense"
                        />
                        <FormControlLabel
                            control={<Checkbox checked={grupoMostrarCierre} onChange={(e) => setGrupoMostrarCierre(e.target.checked)} />}
                            label="Mostrar en Cierre de Caja"
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpenGrupoModal(false)} color="secondary">Cancelar</Button>
                        <Button onClick={handleGuardarGrupo} color="primary">Guardar</Button>
                    </DialogActions>
                </Dialog>
                {/* </div> */}
            </div>
        </div>
    );
};

export default GestionTipoTransacciones;
